export default __webpack_public_path__ + "static/media/documenticondark.5887aa17.svg";